/**
 * Reports Web Vitals performance metrics using the provided callback function.
 * @param {Function} onPerfEntry - Callback function to handle performance entries.
 * The callback receives performance metrics for:
 * - CLS (Cumulative Layout Shift)
 * - FID (First Input Delay) 
 * - FCP (First Contentful Paint)
 * - LCP (Largest Contentful Paint)
 * - TTFB (Time to First Byte)
 * @returns {void}
 */
const reportWebVitals = onPerfEntry => {
  if (onPerfEntry && onPerfEntry instanceof Function) {
    import('web-vitals').then(({ getCLS, getFID, getFCP, getLCP, getTTFB }) => {
      getCLS(onPerfEntry);
      getFID(onPerfEntry);
      getFCP(onPerfEntry);
      getLCP(onPerfEntry);
      getTTFB(onPerfEntry);
    });
  }
};

export default reportWebVitals;
